var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiAssistanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 0L9.14614 0.659203C9.32621 1.22811 9.77189 1.67379 10.3408 1.85386L11 2.0625L10.3408 2.27114C9.77189 2.45121 9.32621 2.89689 9.14614 3.4658L8.9375 4.125L8.72886 3.4658C8.54879 2.89689 8.10311 2.45121 7.5342 2.27114L6.875 2.0625L7.5342 1.85386C8.10311 1.67379 8.54879 1.22811 8.72886 0.659203L8.9375 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04167 0.916626L5.5945 3.08793C5.8844 4.22651 6.77345 5.11556 7.91202 5.40546L10.0833 5.95829L7.91202 6.51113C6.77345 6.80102 5.8844 7.69007 5.5945 8.82865L5.04167 11L4.48883 8.82865C4.19894 7.69008 3.30988 6.80102 2.17131 6.51113L0 5.95829L2.17131 5.40546C3.30988 5.11556 4.19894 4.22651 4.48883 3.08793L5.04167 0.916626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistanceIcon);
export default __webpack_public_path__ + "static/media/ai-assistance-icon.8d840bf5d297b3e883a8c91522114e46.svg";
export { ForwardRef as ReactComponent };